import { createWidgetMixin } from 'vue-instantsearch';

let placeName;

const connectPlaces = (
  renderFn,
  unmountFn
) => (/* widgetParams, if this would become reusable */) => {
  return {
    init() {
      renderFn({ nearMe: undefined }, true);
    },
    render({ state }) {
      renderFn({ nearMe: state.aroundLatLngViaIP === 'true' }, false);
    },
    dispose() {
      unmountFn();
    },
    getWidgetState(uiState, { searchParameters }) {
      return {
        ...uiState,
        latlng: searchParameters.aroundLatLng,
        nearme: searchParameters.aroundLatLngViaIP,
        place: placeName,
      };
    },
    getWidgetSearchParameters(searchParameters, { uiState }) {
      placeName = uiState.place;
      return searchParameters
        .setQueryParameter('aroundLatLng', uiState.latlng)
        .setQueryParameter('aroundLatLngViaIP', uiState.nearme);
    },
  };
};

export default {
  mixins: [createWidgetMixin({ connector: connectPlaces })],
  render: () => null,
};
